import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import Featured from "./components/Featured";
import Collections from "./components/Collections";
import Categories from "./components/Categories";
import DeepDive from "./components/DeepDive";
import Faq from "./components/Faq";
import AboutContact from "./components/AboutContact";
import Footer from "./components/Footer";
import SearchModal from "./components/SearchModal";
import BackToTop from "./components/BackToTop";

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [showTop, setShowTop] = useState(false);
  const [activeCategory, setActiveCategory] = useState("全部");
  const [searchOpen, setSearchOpen] = useState(false);
  const [query, setQuery] = useState("");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      setShowTop(window.scrollY > 560);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="bg-background-50">
      <Navbar
        scrolled={scrolled}
        onOpenSearch={() => {
          setQuery("");
          setSearchOpen(true);
        }}
      />
      <main>
        <Hero onOpenSearch={() => setSearchOpen(true)} />
        <Trending />
        <Featured active={activeCategory} onSelect={setActiveCategory} />
        <Collections />
        <Categories onPick={setActiveCategory} />
        <DeepDive />
        <Faq />
        <AboutContact />
      </main>
      <Footer />
      <BackToTop visible={showTop} />
      <SearchModal open={searchOpen} query={query} setQuery={setQuery} onClose={() => setSearchOpen(false)} />
    </div>
  );
}